import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const ErrorFallback = props => {
  const navigate = useNavigate();
  const { error, resetErrorBoundary } = props;
  const [open, setOpen] = useState(true);

  return (
    <>
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{'Opps!'}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Something went wrong while handling your request, please retry or
            navigate to home.
            <br />
            <small>
              <i>{error?.message || ''}</i>
            </small>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              resetErrorBoundary();
              setOpen(false);
            }}
          >
            Try again
          </Button>
          <Button
            onClick={() => {
              setOpen(false);
              navigate('/dashboard');
              window.location.reload();
            }}
            autoFocus
          >
            Dashboard
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ErrorFallback;
